module.exports = __webpack_public_path__ + "img/ico-tarefa-branca.c840c1c6.png";